import React from "react";
import { InputNumber, Typography } from "antd";
import { InputContainer } from "./styles";

interface InputNumberComponentProps {
	title?: string;
	style?: React.CSSProperties;
	isRequired?: boolean;
	value?: string | number | undefined;
	onChange?: (value: string | number | null ) => void;
	placeholder?: string;
	error?: boolean;
	isDisabled?: boolean;
	size?: "small" | "middle" | "large";
	readonly?: boolean;
	positiveOnly?: boolean;
}

const InputNumberComponent = ({
	title,
	style,
	isRequired = false,
	value = "",
	onChange,
	placeholder = "Lütfen giriniz",
	error = false,
	isDisabled,
	size = "large",
	readonly = false,
	positiveOnly = false,
}: InputNumberComponentProps) => {
	const status = error ? "error" : undefined;

	return (
		<InputContainer>
			{title &&(
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			<InputNumber
				size={size}
				style={{ 
					width: "100%",
					height: "40px",
					marginBottom: "10px",
					cursor: readonly ? "not-allowed" : "auto", 
					...style 
				}}
				status={status}
				value={value}
				min={positiveOnly ? 1 : undefined}
				onChange={onChange}
				disabled={isDisabled}
				placeholder={placeholder}
				readOnly={readonly}
				onKeyPress={(event) => {
					if (!/[0-9]/.test(event.key)) {
						event.preventDefault();
					}
				}}
			/>
		</InputContainer>
	);
};

export default InputNumberComponent;
